import ButtonIcon from "components/ButtonIcon/ButtonIcon";
import { Tooltip } from "components/Tooltip/Tooltip";
import { useState } from "react";
import type { Lien } from "../LienTypes";
import GenerateLienDocumentModal from "./GenerateLienDocumentModal";

type GenerateLienDocumentButtonProps = {
  lienId: string;
  lien?: Lien;
};

const GenerateLienDocumentButton = ({
  lienId,
  lien,
}: GenerateLienDocumentButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Tooltip content="Generate Document">
        <ButtonIcon kind="neutral" onClick={() => setShowModal(true)}>
          downloading
        </ButtonIcon>
      </Tooltip>

      <GenerateLienDocumentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        lienId={lienId}
        lien={lien}
      />
    </>
  );
};

export default GenerateLienDocumentButton;
